// 配置管理相关接口
import request from "@/utils/request";

/**** 杭州博乐 新增接口 start *****/

// 新增安卓的版本 versionUpload
export function versionUpload(data) {
  return request({
    url: "/version/add",
    method: "post",
    data,
  });
}

// 安卓的版本管理 /version/newest
export function versionNewest() {
  return request({
    url: "/version/newest",
    method: "post",
  });
}

// 领域管理- 删除
export function fieldDelete(data) {
  return request({
    url: "/field/delete",
    method: "post",
    params: { ...data },
  });
}

// 领域的新增和编辑
export function fieldAddOrEdit(data) {
  return request({
    url: "/field/addOrEdit",
    method: "post",
    data,
  });
}

export function spaceList(data) {
  return request({
    url: "/space/page",
    method: "post",
    data,
  });
}

// 空间管理--新增/编辑 
export function spaceAddOrEdit(data) {
  return request({
    url: "/space/addOrEdit",
    method: "post",
    data,
  });
}

// 空间管理 - 详情查看 /space/detail
export function spaceDetail(data) {
  return request({
    url: "/space/detail",
    method: "post",
    params: { ...data },
  });
}

// 空间的删除操作 
export function spaceDelete(data) {
  return request({
    url: "/space/delete",
    method: "post",
    params: { ...data },
  });
}

// 资源列表
export function resourceList(data) {
  return request({
    url: "/resource/page",
    method: "post",
    data,
  });
}

// 资源编辑 
export function resourceAddOrEdit(data) {
  return request({
    url: "/resource/addOrEdit",
    method: "post",
    data,
  });
}

// 删除资源
export function resourceDelete(data) {
  return request({
    url: "/resource/delete",
    method: "post",
    params: { ...data },
  });
}



// 作品管理- 分页 /work/admin/page
export function workPage(data) {
  return request({
    url: "/work/admin/page",
    method: "post",
    data,
  });
}

// 作品管理 - 删除 
export function workDelete(data) {
  return request({
    url: "/work/delete",
    method: "post",
    params: { ...data },
  });
}




// 领域管理 - 列表 /field/page
export function fieldPage(data) {
  return request({
    url: "/field/page",
    method: "post",
    data,
  });
}


// 作品统计 ： 作者数量和作品数量 
export function queryWorkAuthorCount() {
  return request({
    url: "/work/admin/queryWorkAuthorCount",
    method: "post",
  });
}

// 作品排行
export function workRank() {
  return request({
    url: "/work/admin/rank",
    method: "post",
  });
}


// 作品统计 - 班级占比
export function clazzRankRatio() {
  return request({
    url: "/work/admin/clazzRatio",
    method: "post",
  });
}

// 作品统计 - 空间占比 /work/admin/spaceRatio
export function spaceRankRatio() {
  return request({
    url: "/work/admin/spaceRatio",
    method: "post",
  });
}

// 签到统计
export function checkInTimeCount() {
  return request({
    url: "/checkIn/timeCount",
    method: "post",
  });
}

export function checkInRank() {
  return request({
    url: "/checkIn/rank",
    method: "post",
  });
}


// 作品统计 - 班级占比
export function checkInRankRatio() {
  return request({
    url: "/checkIn/admin/clazzRatio",
    method: "post",
  });
}

// 作品统计 - 空间占比 /work/admin/spaceRatio
export function checkInSpaceRatio() {
  return request({
    url: "/checkIn/admin/spaceRatio",
    method: "post",
  });
}



/**** 杭州博乐 新增接口 end *****/





// 请假列表
export function leaveTypeList(data) {
  return request({
    url: "/leaveType/page",
    method: "post",
    data,
  });
}

// 请假类型--新增/编辑 /leaveType/addOrEdit
export function leaveTypeAddOrEdit(data) {
  return request({
    url: "/leaveType/addOrEdit",
    method: "post",
    data,
  });
}

// 删除请假类型 /leaveType/delete
export function leaveTypeDelete(data) {
  return request({
    url: "/leaveType/delete",
    method: "post",
    params: { ...data },
  });
}

// 签到统计 /stampType/page
export function stampTypeList(data) {
  return request({
    url: "/stampType/page",
    method: "post",
    data,
  });
}

// 签到统计--新增/编辑 /stampType/addOrEdit
export function stampTypeAddOrEdit(data) {
  return request({
    url: "/stampType/addOrEdit",
    method: "post",
    data,
  });
}

// 删除签到统计 /stampType/delete
export function stampTypeDelete(data) {
  return request({
    url: "/stampType/delete",
    method: "post",
    params: { ...data },
  });
}

// 供应商管理 /supplier/page


// 供应商管理--新增/编辑 /supplier/addOrEdit


// 删除供应商 /supplier/delete


// 食材物资 /foodMaterial/page
export function foodMaterialList(data) {
  return request({
    url: "/foodMaterial/page",
    method: "post",
    data,
  });
}

// 食材物资--新增/编辑 /foodMaterial/addOrEdit
export function foodMaterialAddOrEdit(data) {
  return request({
    url: "/foodMaterial/addOrEdit",
    method: "post",
    data,
  });
}

// 删除食材物资 /foodMaterial/delete
export function foodMaterialDelete(data) {
  return request({
    url: "/foodMaterial/delete",
    method: "post",
    params: { ...data },
  });
}

// 空间管理 /department/page



// 删除部门 /department/delete



// 角色管理--新增/编辑 /role/addOrEdit
export function roleAddOrEdit(data) {
  return request({
    url: "/role/addOrEdit",
    method: "post",
    data,
  });
}

// 删除角色 /role/delete
export function roleDelete(data) {
  return request({
    url: "/role/delete",
    method: "post",
    params: { ...data },
  });
}

// 获取角色详情 /role/detail
export function roleDetail(data) {
  return request({
    url: "/role/detail",
    method: "post",
    params: { ...data },
  });
}

// 查询所有的权限 /permission/findAll
export function findAll() {
  return request({
    url: "/permission/findAll",
    method: "post",
  });
}

// 类型管理
export function applicationType(data) {
  return request({
    url: "/applicationType/page",
    method: "post",
    data,
  });
}

// 类型详情 /applicationType/detail

export function applicationTypeDetail(data) {
  return request({
    url: "/applicationType/detail",
    method: "post",
    params: { ...data },
  });
}

// 类型编辑 
export function applicationTypeEdit(data) {
  return request({
    url: "/applicationType/addOrEdit",
    method: "post",
    data,
  });
}

// 类型删除
export function applicationTypeDelete(data) {
  return request({
    url: "/applicationType/delete",
    method: "post",
    params: { ...data },
  });
}

